var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row align-items-center justify-content-center text-center ps-0",attrs:{"id":"main-row"}},[_c('div',{staticClass:"col"},[_c('span',{staticClass:"spinner-border spinner-border text-primary",attrs:{"role":"status","aria-hidden":"true"}})])])
}]

export { render, staticRenderFns }